import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

export const getIncomingApplications = createAsyncThunk(
  "getIncomingApplications",
  async (applicationStatus) => {
    const token = localStorage.getItem("cu_user");
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_HOST}/api/audit?status=${applicationStatus}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return data.data;
    } catch (error) {
      console.error(error);
    }
  }
);

export const getIncomingApplicationById = createAsyncThunk(
  "getIncomingApplicationById",
  async (applicationId) => {
    const token = localStorage.getItem("cu_user");
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_HOST}/api/audit/${applicationId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return data.data;
    } catch (error) {
      console.error(error);
    }
  }
);

export const getCount = createAsyncThunk("getCount", async () => {
  try {
    const token = localStorage.getItem("cu_user");
    const { data } = await axios.get(
      `${process.env.REACT_APP_API_HOST}/api/audit/agg-status/count`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return data.data;
  } catch (error) {
    console.error(error);
  }
});

export const approveApplication = createAsyncThunk(
  "approveApplication",
  async ({ id, values }) => {
    return toast.promise(
      new Promise(async (resolve, reject) => {
        const token = localStorage.getItem("cu_user");
        try {
          let res = await axios.patch(
            `${process.env.REACT_APP_API_HOST}/api/audit/report/${id}`,
            values,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          if (res?.data?.status === "success") {
            resolve(res);
            return res?.data;
          }
        } catch (error) {
          reject(error?.response?.data);
        }
      }),
      {
        pending: "Approving...",
        success: "Application approved successfully",
        error: {
          render({ data }) {
            return `${data?.message}`;
          },
        },
      }
    );
  }
);

export const cancelAudit = createAsyncThunk(
  "approveApplication",
  async ({ id, values }) => {
    return toast.promise(
      new Promise(async (resolve, reject) => {
        const token = localStorage.getItem("cu_user");
        try {
          let res = await axios.post(
            `${process.env.REACT_APP_API_HOST}/api/audit/cancel/${id}`,
            values,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          if (res?.data?.status === "success") {
            resolve(res);
            return res?.data;
          }
        } catch (error) {
          reject(error?.response?.data);
        }
      }),
      {
        pending: "processing...",
        success: "Audit cancelled successfully",
        error: {
          render({ data }) {
            return `${data?.message}`;
          },
        },
      }
    );
  }
);

export const AuditorSlice = createSlice({
  name: "Auditor",
  initialState: {
    incomingApplications: [],
    application: null,
    counts: [],
    status: "idle",
    isloading: true,
    error: null,
  },
  reducers: {},
  extraReducers: {
    [getIncomingApplications.pending]: (state) => {
      state.status = "pending";
      state.isloading = true;
    },
    [getIncomingApplications.fulfilled]: (state, action) => {
      state.status = "success";
      state.incomingApplications = action.payload;
      state.isloading = false;
    },
    [getIncomingApplications.rejected]: (state, action) => {
      state.status = "failed";
      state.error = action.error;
      state.isloading = true;
    },

    [getIncomingApplicationById.pending]: (state) => {
      state.status = "pending";
    },
    [getIncomingApplicationById.fulfilled]: (state, action) => {
      state.application = action.payload;

      state.status = "success";
    },
    [getIncomingApplicationById.rejected]: (state, action) => {
      state.error = action.error;
      state.status = "failed";
    },
    [getCount.pending]: (state) => {
      state.status = "pending";
    },
    [getCount.fulfilled]: (state, action) => {
      state.status = "success";
      state.counts = action.payload;
    },
    [getCount.rejected]: (state, action) => {
      state.status = "failed";
      state.error = action.error;
    },
  },
});

export default AuditorSlice.reducer;
